<template>
    <h1>Register</h1>
    <v-form ref="form">
        <v-container density="compact">
            <div v-if="unregistered">
                <div>
                    This page will allow you to register as a user with the Participant Portal and check the status of your application once submitted.
                </div>
                <div>
                    To do so, click 'Register' below, and click the 'Sign Up' button on the next screen:

                </div>
                <div style="display: flex; justify-content: center; align-items: center; height: 100%;">
                    <v-img src="@/assets/auth0_signup_screen.png" alt="Wyoming Department of Health" style="width: 250px; max-height: 462px; float: inherit;" />
                </div>
                <v-btn @click="login">Register</v-btn>
            </div>
            <div v-else-if="registered">
                You are already registered and logged in. Select 'Application' on the left menu to submit an application, or 'Application Status' to check the status of an existing Application.
            </div>
           
        </v-container>
    </v-form>
</template>

<script setup lang="ts">
    import { onMounted, ref } from 'vue'
    import { useAuth0 } from "@/Services/Auth0/auth0-plugin";

    const auth0 = useAuth0();

    const getAccessToken = async () => {
        if (!auth0) {
            return null;
        }

        return await auth0.getAccessToken();
    };


    let unregistered = ref(true)
    let registered = ref(false)
    let isAuthenticated = false

    onMounted(async () => {
        try {
            const token = await getAccessToken();

            if (!token) {
                unregistered.value = true;
                registered.value = false;
            } else {
                unregistered.value = false;
                registered.value = true;
                isAuthenticated = auth0 ? auth0.isAuthenticated.value : false;
                console.log('Application Status Page is auth0 authenticated: ' + isAuthenticated);
            }
        } catch {
            console.log('Not Authenticated.');
        }
    });

    const login = () => {
        if (!auth0) {
            console.log('Hit !auth0 on Register Button');
            return;
        }
        console.log('Hitting auth0.login on Register');
        auth0.login({
            appState: {
                target: "/application",
            },
            authorizationParams: {
                prompt: "login",
                screen_hint: "signup",
            }
        });
    };



</script>

<style>
</style>